/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DeleteFinancialAgreementByHcsIdRequest = {
  /**
   * 고객고유번호
   */
  hcs_id: string;
  /**
   * 동의관리번호
   */
  hcs_consent_num: string;
  /**
   * FINANCIAL_MANAGEMENT / FINANCIAL_MANAGEMENT_3RD
   */
  feature_name: DeleteFinancialAgreementByHcsIdRequest.feature_name;
  /**
   * HCS 호출하지 않은 철회 요청은 true
   */
  is_di_call?: boolean;
};
export namespace DeleteFinancialAgreementByHcsIdRequest {
  /**
   * FINANCIAL_MANAGEMENT / FINANCIAL_MANAGEMENT_3RD
   */
  export enum feature_name {
    UBI = 'UBI',
    CPO = 'CPO',
    CONSUMABLES = 'CONSUMABLES',
    DIAGNOSTICS = 'DIAGNOSTICS',
    TRIPS = 'TRIPS',
    SAFETY_SCORE = 'SAFETY_SCORE',
    TRIP_FUEL = 'TRIP_FUEL',
    BRAKE_SERVICE = 'BRAKE_SERVICE',
    TIRE_SERVICE = 'TIRE_SERVICE',
    ENGINE_SERVICE = 'ENGINE_SERVICE',
    BATT_SERVICE = 'BATT_SERVICE',
    REFUEL = 'REFUEL',
    FUEL_EFFICIENCY = 'FUEL_EFFICIENCY',
    FINANCIAL_MANAGEMENT = 'FINANCIAL_MANAGEMENT',
    FINANCIAL_MANAGEMENT_3RD = 'FINANCIAL_MANAGEMENT_3RD',
    BATTERY_PFRM_MNG_DI_SERVICE = 'BATTERY_PFRM_MNG_DI_SERVICE',
    BATTERY_PFRM_MNG_SERVICE = 'BATTERY_PFRM_MNG_SERVICE',
    NONE = 'NONE',
  }
}

